/* eslint-disable import/no-cycle */
import api from './api.service';

function index(params) {
  return api.get('/editors/', params);
}

function get(id, params) {
  return api.get(`/editors/${id}`, params);
}

function create(params) {
  return api.post('/editors', params);
}

function update(id, params) {
  return api.put(`/editors/${id}/update`, params);
}

function remove(id, params) {
  return api.delete(`/editors/${id}`, params);
}

function save(params) {
  return (params.id) ? update(params.id, params) : create(params);
}

function exportData(params) {
  return api.get('/editors/export', params);
}

export const editorsService = {
  index,
  get,
  create,
  update,
  remove,
  save,
  exportData,
};
